import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  token: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    login: (state, action) => {
      state.user = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
    },

    loadFromStorage: (state) => {
      const token = localStorage.getItem("authToken");
      const raw = localStorage.getItem("user");
      if (token && raw) {
        try {
          const user = JSON.parse(raw);
          state.token = token;
          state.user = user;
        } catch (e) {
          console.error("Failed to parse user from storage", e);
        }
      }
    },
  },
});

export const { login, setToken, logout, loadFromStorage } = userSlice.actions;

export default userSlice.reducer;
